function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "595.28px",
    viewBox: "0 0 351.777 360.822",
    enableBackground: "new 0 0 595.28 595.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -121, -117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.274,269.102c0,81.172,65.805,146.977,146.975,146.977s146.975-65.805,146.975-146.977 c0-81.173-65.805-146.982-146.975-146.982S175.274,187.929,175.274,269.102z M213.015,269.102 c0-60.333,48.908-109.233,109.234-109.233s109.232,48.9,109.232,109.233c0,60.328-48.906,109.233-109.232,109.233 S213.015,329.43,213.015,269.102z",
    style: {
      fill: "rgba(255, 255, 255, 0.46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.626,434.893l62.682-62.688c9.471,11.646,20.551,21.903,32.836,30.571l-63.814,63.819 c-4.377,4.376-10.117,6.566-15.854,6.566c-5.734,0-11.475-2.19-15.85-6.566C123.866,457.842,123.866,443.649,132.626,434.893z",
    style: {
      fill: "rgba(255, 255, 255, 0.46)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e20ce323.svg";
export { ForwardRef as ReactComponent };